import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@principle-theorem/ai-scribe-sdk';
import { createFirestore } from '@principle-theorem/ng-shared';
import { initializeApp } from 'firebase/app';
import * as LogRocket from 'logrocket';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.__PT_VOX_SDK_PRODUCTION__ = true;

  if (environment.logRocketKey) {
    LogRocket.init(environment.logRocketKey, {
      console: {
        shouldAggregateConsoleErrors: true,
      },
    });
  }
}

if (environment.useEmulator) {
  initializeApp(environment.firebase);
  createFirestore(true);
}

void platformBrowserDynamic().bootstrapModule(AppModule);
